// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--klecL","future-type-icon":"_02712f2b3b--future-type-icon--QbDB_","input":"_02712f2b3b--input--RAbDx","icon":"_02712f2b3b--icon--iF5df"};